import React, { useContext, useEffect, useState } from "react";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { APICall } from "../../Helpers/Network/APICalls";
import { loanModuleGetPersonalDetailsByMemberId } from "../../Helpers/APIEndPoints/EndPoints";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { useSelector } from "react-redux";

const StatusApprovalScreen = (props) => {
  

  const context = getContext();
  let MemberId = context.MemberId;
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [statusId, setStatusId] = useState<any>();
  const [statusMessage, setStatusMessage] = useState<any>();
  const [ReasonMessage, setReasonMessage] = useState<any>();

  const loanParameters = useSelector<any>(
    (state) => state?.LoanModuleReducer?.loanParameters
  );
  useEffect(() => {
    getPersonalDetailsById();
  }, []);

  const getPersonalDetailsById = async () => {
    showLoader();
    let requestParams = loanParameters; //{ MemberId: MemberId };
    const res = await APICall(
      loanModuleGetPersonalDetailsByMemberId,
      requestParams
    );
    if (res.Message === "Ok" && res.Data !== null) {
      
      setStatusId(res?.Data?.Lrd_StatusId);
      let last4 = res?.Data?.Mkd_AccountNo.toString().slice(-4);
      if(res?.Data?.StatusMessage != null){
        setStatusMessage(
          res?.Data?.StatusMessage.replaceAll(
            "{ACCOUNT_NUMBER}",
            last4
          )
        );
      }
      if (res?.Data?.Lrh_Remarks) {
        setReasonMessage(res?.Data?.Lrh_Remarks);
      }

      hideLoader();
    } else {
      notify(ToastType.Error, "Data not found");
      hideLoader();
    }
  };

  const StatusView = () => {
    let color;
    let icon;
    if (
      [
        LoanStatus.LoanModule_PendingWithInternalTeam,
        LoanStatus.LoanModule_PendingMemberLoanConfirmation,
        LoanStatus.LoanModule_SuretyApprovalPending,
        LoanStatus.LoanModule_LoanAgreementPending,
        LoanStatus.LoanModule_MemberSignaturePending,
        LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
        LoanStatus.LoanModule_LoanCommitteeApprovalPending,
        LoanStatus.LoanModule_LoanFinalApprovalPending,
        LoanStatus.LoanModule_DocumentGenerationPending,
        LoanStatus.LoanModule_LoanInprogress,
      ].includes(statusId)
    ) {
      color = "#7ac143";
      icon = <i className="fa fa-hourglass-half" aria-hidden="true"></i>;
    } else if (
      [
        LoanStatus.LoanModule_LoanApplicationApproved,
        LoanStatus.LoanModule_AllSuretyApproved,
        LoanStatus.LoanModule_LoanCompleted,
      ].includes(statusId)
    ) {
      color = "#7ac143";
      icon = <i className="far fa-check-circle" aria-hidden="true"></i>;
    } else if (
      [
        LoanStatus.LoanModule_RejectedByInternalTeam,
        LoanStatus.LoanModule_LoanApplicationCancelledByMember,
        LoanStatus.LoanModule_MemberSignatureVerificationRejected,
        LoanStatus.LoanModule_MemberAgreementRejected,
        LoanStatus.LoanModule_LoanApplicationRejected,
      ].includes(statusId)
    ) {
      color = "#db233a";
      icon = <i className="fa fa-ban" aria-hidden="true"></i>;
    }

    return (
      <div>
        <div
          style={{
            textAlign: "center",
            fontWeight: 500,
            fontSize: "18px",
          }}
        >
          <div
            style={{
              marginBottom: "10px",
              fontSize: "100px",
              color: color,
            }}
          >
            {icon}
          </div>
          {statusMessage}
          <p>{ReasonMessage && ReasonMessage}</p>
        </div>
      </div>
    );
  };

  return (
    <>
      <StatusView />
    </>
  );
};

export default StatusApprovalScreen;
